import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from 'utils/BackgroundJobs';
import { Acknowledgement } from 'graphql/entities';

import { getMutationProps, getRangeMutationProps } from './DocumentAction';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Acknowledgement',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    Acknowledgement.generate,
    getMutationProps(state, props, variables),
    props,
    returnUrl,
    'Generate Acknowledgement',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    Acknowledgement.generateRange,
    getRangeMutationProps(state, props, variables, 'salesOrders'),
    props,
    returnUrl,
    'Generate Acknowledgement',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

/**
 * Reprints a set of acknowledgements (Provided as an array within variables).
 */
export function reprintRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    Acknowledgement.reprint,
    getRangeMutationProps(state, props, variables, 'acknowledgements'),
    props,
    returnUrl,
    'Generate Acknowledgement',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}
